import React, { useState, useEffect } from 'react';
import axios from 'axios';

const VisitorCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    // Increment visitor count on component mount
    axios.post('/api/visitor-count')
      .then(response => {
        if (response.data && response.data.count !== undefined) {
          setCount(response.data.count);
        }
      })
      .catch(error => {
        console.error('Error updating visitor count:', error);
        // Set a default count if API fails
        setCount(1000);
      });
  }, []);

  if (count === null) {
    return null; // Don't show anything while loading
  }

  // Format number with commas
  const formattedCount = count.toLocaleString();

  return (
    <div className="visitor-counter text-center mb-3" style={{ fontSize: '0.9rem', color: '#000000', opacity: 0.8 }}>
      <i className="bi bi-people me-2"></i>
      <strong>{formattedCount}</strong> couples served
    </div>
  );
};

export default VisitorCounter;


